export const firebaseConfig = {
    apiKey: 'AIzaSyCZThF6W51AQpdnjsq4w9xctswCoj2qu3Q',
    authDomain: 'tfnsw4.firebaseapp.com',
    projectId: 'tfnsw4',
    storageBucket: 'tfnsw4.appspot.com',
    messagingSenderId: '404864314253',
    appId: '1:404864314253:web:c2f33288d98a8bc6a5ebc4',
}
